import {
  CREATE_JOB_REQUEST,
  CREATE_JOB_SUCCESS,
  CREATE_JOB_FAIL
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";

export const CreateJobFormAction = (data, navigate) => {
  return function (dispatch) {
    dispatch({
      type: CREATE_JOB_REQUEST,
      payload: true,
    });
    return new Promise((resolve, reject) => {
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/add_jobs`,
        method: "POST",
        data: data,
        headers: {
          //   "content-type": "application/json",
          "Content-Type": "multipart/form-data",
        },
      };
      try {
        axios(OPTION)
          .then((res) => {
            console.log("check res of reduc in", res);
            dispatch(CreateJobFormPre(res.data, navigate));
            resolve(res?.data);
          })
          .catch((error) => {
            console.log("check erre of reduc in", error);
            dispatch({
              type: CREATE_JOB_FAIL,
              payload: false,
              error: error,
              createJob: error.success,
              msg: "Failed to create user registration",
            });
            toast.error(error?.response?.data?.status?.message ?? "Internal server error");
            return reject(error)
          });
      } catch (err) {
        console.log("myerrr", err)
      }
    })


  };
};

export const CreateJobFormPre = (data, navigate) => {
  toast.success("Job Created Successfully!");
  setTimeout(() => {
    //   window.location.href = "/posted_jobs";
    navigate('/posted_jobs')
  }, 2000);
  return {
    type: CREATE_JOB_SUCCESS,
    createJob: data.status.message,
    result: data,
    payload: false,
    msg: data.status.message,
  };
};